import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AnalisisService } from 'src/app/servicios/analisis/analisis.service';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';
import { CuadrossalidaService } from 'src/app/servicios/cuadrossalida/cuadrossalida.service';
import { catchError, timeout } from 'rxjs/operators';
import { throwError } from 'rxjs';
import * as XLSX from 'xlsx';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-cuadrosSalidaFivi',
  templateUrl: './cuadrosSalidaFivi.component.html',
  styleUrls: ['./cuadrosSalidaFivi.component.css']
})
export class CuadrosSalidaFiviComponent implements OnInit {

  botones : Boolean = true;
  cuadrosSalida : any;
  trimestreActual : any = "I";
  anioActual : any = "I";
  nombreDescarga : any = "";
  stringBase64 : any = "";
  botonDescarga : Boolean = false;

  @ViewChild('openmodalcargando') openmodalcargando: ElementRef;
  @ViewChild('closemodacargando') closemodacargando: ElementRef;

  @ViewChild('openmodalicoced') openmodalicoced: ElementRef;
  @ViewChild('closemodalicoced') closemodalicoced: ElementRef;

  @ViewChild('openmodalserie') openmodalserie: ElementRef;
  @ViewChild('closemodalserie') closemodalserie: ElementRef;

  icoced= new FormControl(null ,[Validators.required, Validators.pattern('^[0-9,]*$')]);
  anioSerie= new FormControl(null ,[Validators.required, Validators.pattern('^[0-9]*$')]);

  serieDescarga: any = "";

  descargaCSoS : Boolean = false;

  cuadroDescarga: any = "";

  constructor(
    private api:ApiService,
    private router:Router,
    private toastr: ToastrService,
    private appService:AppServiceService,
    private cuadrosSalidaService:CuadrossalidaService,
    private analisisService:AnalisisService,
  ) { }

  ngOnInit() {
    this.botones = false;


    this.cuadrosSalidaService.verificarExisteIcoced().subscribe(
      result =>{
        this.cargarPrimerosDatos();

        if(!result){
          this.iniciarIcoced();
        }
      }
    );

  }

  RegresarCuadrosSalida(){
    this.router.navigate(['CuadrosSalida']);
  }

  cargarPrimerosDatos(){
    this.analisisService.consultarPeriodoActivoFIVI().subscribe(Result=>{
      this.anioActual = Number(Result.anio);
      if(Number(Result.consecutivoPeriodo)>=1&&Number(Result.consecutivoPeriodo)<=3){
        this.anioActual = Number(this.anioActual) - 1;
        this.trimestreActual = 4;
      }
      if(Number(Result.consecutivoPeriodo)>=4&&Number(Result.consecutivoPeriodo)<=6){
        this.trimestreActual = 1;
      }
      if(Number(Result.consecutivoPeriodo)>=7&&Number(Result.consecutivoPeriodo)<=9){
        this.trimestreActual = 2;
      }
      if(Number(Result.consecutivoPeriodo)>=10&&Number(Result.consecutivoPeriodo)<=12){
        this.trimestreActual = 3;
      }
    });
  }

  iniciarIcoced(){
    //this.nombreDescarga = nombre;
    //this.descargaCSoS = true;
    this.openmodalicoced.nativeElement.click();
  }

  guardarIcoced(){
    this.cuadrosSalidaService.guardarIcoced(this.icoced.value).subscribe(
      result =>{
        if(result){
          this.closemodalicoced.nativeElement.click();
        }
      }
    );
  }

  iniciarSerie(nombre, cuadro){
    this.nombreDescarga = nombre;
    this.serieDescarga = cuadro;
    this.descargaCSoS = false;
    this.openmodalserie.nativeElement.click();
  }

  iniciarDescarga(nombre, cuadro){
    this.cuadroDescarga = cuadro;

    let parametro: any = null;

    this.botonDescarga = false;
    this.nombreDescarga = nombre;

    if(this.descargaCSoS){
      this.closemodalicoced.nativeElement.click();
      parametro = this.icoced.value;
    }else{
      this.closemodalserie.nativeElement.click();
      parametro = this.anioSerie.value;
    }

    this.openmodalcargando.nativeElement.click();
    this.cuadrosSalidaService.getCuadroSalidaFivi(cuadro, parametro).pipe(
      timeout(300000),
      catchError(err => {
        if (err.name === 'TimeoutError') {
          console.error("Error de tiempo de espera:", err);
        } else {
          console.error("Error:", err);
        }
        return throwError(err);
      })
    ).subscribe({
      next: (resultado) => {
        if (resultado != undefined || resultado != null) {
          this.stringBase64 = resultado.data;
          this.botonDescarga = true;

        } else {
          console.log("error " + resultado);
        }
      },
      error: (err) => {
        if (err.status === 500) {
          this.toastr.error('Error al formular archivo.', 'Error!');
          this.closemodacargando.nativeElement.click();
        } else {
          console.error("Error:", err);
        }
      }
    });
  }

  descargarArchivo() {
    if (this.stringBase64) {
      const blob = this.base64toBlob(this.stringBase64);
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = this.nombreDescarga;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } else {
      console.error('No hay datos para descargar');
    }
    this.closemodacargando.nativeElement.click();
    this.cuadroDescarga = "";
    this.botonDescarga = false;
    this.nombreDescarga = "";
    this.stringBase64 = "";
    this.cancelarDescarga();
  }


  base64toBlob(base64Data: string): Blob {
    const sliceSize = 512;
    const byteCharacters = atob(base64Data);
    const byteArrays: Uint8Array[] = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    if(this.cuadroDescarga=='S1'){
      return new Blob(byteArrays, { type: 'text/csv' });
    }else{
      return new Blob(byteArrays, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    }
  }

  cancelarDescarga(){
    this.icoced.setValue(null);
    this.anioSerie.setValue(null);
  }

}
